module.exports = __webpack_public_path__ + "static/media/doctor-conversation-no-frame.0680eefe.png";